import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

const propTypes = {
  createAction: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
};

const CreateButton = ({ createAction, content }) => (
  <Button
    color="green"
    content={<span>New&nbsp;{content}</span>}
    icon="add"
    labelPosition="left"
    onClick={createAction}
  />
);

CreateButton.propTypes = propTypes;
export default CreateButton;



// WEBPACK FOOTER //
// ./src/components/CreateButton.jsx